/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';

class Browser extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object
    };

    render() {
        const {msg} = this.props;
        return (
            <div id="messages-page" className="pageNotification">
              <h1 className="pageLogin-logo view-big">{msg.global.appName}</h1>
                <div className="pageNotification-content view-big">
                        <h2 className="pageNotification-title">
                            {msg.browser.line1} <br/>
                            {msg.browser.line2}
                        </h2>
                        <div style={{marginTop: '50px'}}>
                            <div className="" style={{textAlign: 'center'}}>
                                <div className="" style={{display: 'inline-block', margin: '20px'}}>
                                    <a href="https://www.google.com/chrome/browser/desktop/index.html" target="_blank">
                                        <img width="80" src="img/browsers/chrome.png"/><br/>
                                        <span>Chrome 55+</span>
                                    </a>
                                </div>
                                <div className="" style={{display: 'inline-block', margin: '20px'}}>
                                    <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">
                                        <img width="80" src="img/browsers/firefox.png"/><br/>
                                        <span>Firefox 50+</span>
                                    </a>
                                </div>
                                <div className="" style={{display: 'inline-block', margin: '20px'}}>
                                    <a href="https://support.apple.com/en-us/HT201541" target="_blank">
                                        <img width="80" src="img/browsers/safari.png"/><br/>
                                        <span>Safari 10+</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale]
}))(Browser);



// WEBPACK FOOTER //
// ./src/browser/device/Browser.js